import React, { useContext, useEffect } from "react";
import CardAgendado from "../../../components/Cards/CardAgendado/Card";
import { Col } from "react-bootstrap";
import { MainContext } from "../../../context/MainContext";
import { PaginationLayout } from "../../PaginationLayout";

const ClassesThatWillHappenListComponent: React.FC = ({}) => {
  const {
    classes, 
    currentPage, 
    loadClassesThatWillHappenToday,
    getSearchInputTextValue} = useContext(MainContext)

  useEffect(() => {
    let isFiltering:boolean = getSearchInputTextValue()!==""

    loadClassesThatWillHappenToday(currentPage,isFiltering)
  }, [currentPage]);

  console.log(classes);
  

  return (
    <PaginationLayout
      reload={loadClassesThatWillHappenToday}
    >
      {classes.map((item: any) => (
        <Col md={"auto"} className="pe-0">
          <CardAgendado
            countStudents={item.countStudents}
            date={item.date}
            descrpiton={item.description}
            startTime={item.startTime}
            endTime={item.endTime}
            name={item.name}
            teachers={item.teachers}
            countTeachers={item.countTeachers}
            joinUrl={item.joinUrl}
          />
        </Col>
      ))}
    </PaginationLayout>
  );
};
export default ClassesThatWillHappenListComponent;


